"use client";

import React from "react";

import CredHomeHeroPortfolio from "@/components/Cred/Home/Hero/Portfolio";
import CredHomeHeroStats from "@/components/Cred/Home/Hero/Stats";
import CredLogo from "@/components/Cred/UI/Logo";
import useHeroStats from "@/hooks/api/cred/useHeroStats";
import BoostInfoPanel from "./BoostPanel";
import CredFlowInfoPanel from "./CredFlowInfoPanel";
import Referral from "./Referral";
import CTA from "@/components/Cred/UI/CTA";
import Link from "next/link";
import Section from "@/components/Cred/UI/CredSection";
import Image from "next/image";
import { SupVault } from "@repo/core-ui";

export default function CredHomeHero() {
  const { data, isLoading } = useHeroStats();

  return (
    <div className="relative bg-gradient-to-b from-primary-25 to-neutral-25">
      <div className="absolute z-10 bg-gradient-to-b from-neutral-25 via-transparent to-neutral-25" />
      <Image className="absolute top-0 z-20 w-full object-cover" src="/assets/img/landing-sm-glow.png" alt="Background Img" fill priority />
      <div className="relative z-40">
        <div className="flex flex-col items-center space-y-10">
          <CredLogo />
          <CredHomeHeroStats isLoading={isLoading} totalCred={data?.cred.total} daysLeft={data?.days_left} totalBoost={data?.boosts.total} />
          <CredHomeHeroPortfolio />
        </div>
        <Section>
          {data && (
            <>
              <div className={`grid grid-cols-1 gap-4 transition-opacity duration-500 md:grid-cols-2 md:gap-8 ${data ? "opacity-100" : "opacity-0"}`}>
                <Referral className="md:col-span-2" />
                <div className="space-y-5">
                  <BoostInfoPanel totalBoost={data.boosts.total} baseBoost={data.boosts.base} tierBoost={data.boosts.tier} superfrenBoost={data.boosts.superfren} />
                  <CTA
                    topChild="BOOST TO EARN. STACK TO MAXIMIZE"
                    bottomChild={
                      <div className="pt-3">
                        <Link
                          href="https://mirror.xyz/superform.eth/uvgaM-jEMmf1mbYyivPLNsY7hyxhoQ34wW8_zQhG2og"
                          className="underline underline-offset-2 hover:no-underline"
                          target="_blank"
                        >
                          LEARN ABOUT EXPLORATION PROGRAM
                        </Link>
                      </div>
                    }
                  />
                </div>
                <div className="space-y-5">
                  <CredFlowInfoPanel
                    perHourTotal={data?.cred.per_hour_total}
                    perHourDeposits={data?.cred.per_hour_deposits}
                    perHourReferralsDirect={data?.cred.per_hour_referrals_direct}
                    perHourReferralsIndirect={data?.cred.per_hour_referrals_indirect}
                    referralsDirect={data?.referrals_direct_count}
                    referralsIndirect={data?.referrals_indirect_count}
                  />
                  <CTA
                    topChild="EARN 20X CRED ON SUPERUSDC!"
                    bottomChild={
                      <div className="pt-3">
                        <Link href="/" className="flex items-center justify-center space-x-1 underline underline-offset-2 hover:no-underline">
                          <SupVault />
                          <span>GO TO SUPERVAULT</span>
                        </Link>
                      </div>
                    }
                  />
                </div>
              </div>
            </>
          )}
        </Section>
      </div>
    </div>
  );
}
